// @flow
import React from 'react';
import { getUsageCalculatorFuncForMetric } from '@components/custom-discounts/mld-for-field/utils';
import { getCurrentMLDRowDimensionValues } from '@components/custom-discounts/utils';
import { areAllValuesInGivenArrayNonNull } from '@src/common-utils/utils';
import { TinyHeaderSpan } from '@presentational/headings/TinyHeaderSpan';
import { formatFloat0DP } from '@components/views/grid-utils/renderers';

import { StyledDropdownWithAccessibility } from '../../../../common-utils/styledComponents';

export const SingleSelectUsageContainer = ({ metricName, mldGuidance, rowValues }) => {
  const currentRowDimValuesArray = getCurrentMLDRowDimensionValues(rowValues);

  if (!areAllValuesInGivenArrayNonNull(currentRowDimValuesArray)) {
    return <TinyHeaderSpan headerText="Please fill all dims!" />;
  }

  const usageCalculatorFunc = getUsageCalculatorFuncForMetric(metricName);
  const usageValue = usageCalculatorFunc(mldGuidance, currentRowDimValuesArray, metricName);

  // Format as integer for numeric values, keep 'N/A' as-is
  // Convert to string as 0 as number is not working properly with the dropdown
  const formattedUsage = String(formatFloat0DP(usageValue));

  return (
    <StyledDropdownWithAccessibility
      disabled={true}
      fluid={true}
      placeholder="Usage"
      selection={true}
      text={formattedUsage}
      value={formattedUsage}
    />
  );
};
